import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { getLanguage } from './utils';
export const PlacesContext = createContext({ language: '', brand: '' });
export const PlacesProvider = ({ children, placesApiUri, language, brand, headers = {}, }) => {
    // eslint-disable-next-line no-param-reassign
    language = getLanguage(language);
    const client = new ApolloClient({
        uri: placesApiUri,
        cache: new InMemoryCache(),
        headers: { ...headers },
    });
    return (_jsx(PlacesContext.Provider, { value: { language, brand }, children: _jsx(ApolloProvider, { client: client, children: children }) }));
};
//# sourceMappingURL=provider.js.map